import { ReturnRequestDto } from "@babackapp/private-api-client/types";
import { getReturnRequestRefundInitialShippingCost } from "./get-return-request-refund-initial-shipping-cost";
import { getReturnRequestRefundPaidShippingCost } from "./get-return-request-refund-paid-shipping-cost";

type GetReturnRequestRefundShippingCostOptions = {
  returnRequest: ReturnRequestDto;
  chargeForRefund?: boolean;
  chargeForInitialShipping?: boolean;
  forceRefundInitialShipping?: boolean;
};

export function getReturnRequestRefundShippingCost({
  returnRequest,
  chargeForRefund,
  chargeForInitialShipping,
  forceRefundInitialShipping,
}: GetReturnRequestRefundShippingCostOptions) {
  const returnShippingAmount = chargeForRefund
    ? getReturnRequestRefundPaidShippingCost({
        refundReturnRequest: returnRequest,
      })
    : 0;
  const initialShippingAmount =
    chargeForInitialShipping || forceRefundInitialShipping
      ? getReturnRequestRefundInitialShippingCost({
          returnRequest,
          forceRefundInitialShipping,
        })
      : 0;

  return returnShippingAmount - initialShippingAmount;
}
